/** News page and headline copy. EN mirrors SV until proper translations are added. */
export const newsTranslationsSv = {
    noRows: 'Inga nyheter som matchar de senaste 14 dagarna',
    headlines: {
        cancellation: {
            nonCash: '{{companyName}} {{issueType}} av {{consideration}} har ej genomförts',
            default: '{{companyName}} {{issueType}} har ej genomförts',
        },
        newCommitments: {
            warrant: '{{companyName}} har erhållit åtaganden inför inlösen av {{name}}',
            issue: '{{companyName}} {{issueType}} har erhållit ytterligare åtaganden',
        },
        publication: {
            noTermsInitially: '{{companyName}} offentliggör en {{issueType}} (villkor kommer senare)',
            guarantorFeeIssue: '{{companyName}} genomför en kvittningsemission avseende {{issueType}}',
            announces: '{{companyName}} offentliggör en {{issueType}}',
            approxAmount: 'om cirka {{amount}}',
            approxShares: 'om cirka {{units}} aktier',
            ipoWithPrice: '{{companyName}} offentliggör detaljer inför en IPO om cirka {{amount}}',
            ipoWithInterval:
                '{{companyName}} offentliggör detaljer inför en IPO om cirka {{amountLow}} - {{amountHigh}}',
            warrant: '{{companyName}} emitterar {{listedPrefix}}teckningsoptioner av serie {{name}}',
            warrantUnlisted: 'onoterade ',
            convertibleCreditLine: '{{companyName}} ingår en kreditfacilitet med konvertibla lån om {{amount}}',
            convertibleLoan: '{{companyName}} upptar ett konvertibellån om {{amount}}',
            warrantsOnly: ' med enbart teckningsoptioner',
            securedTo: ' säkerställd till {{rate}}',
            regardingNonCash: ' avseende {{consideration}}',
        },
        terms: {
            warrant: '{{companyName}} offentliggör teckningskurs {{price}} {{currency}} för {{name}}',
            issue: '{{companyName}} offentliggör villkor för tidigare aviserad {{issueType}}',
        },
        outcome: {
            preliminary: '{{companyName}} preliminärt utfall: Teckningsgrad {{rate}}',
            final: '{{companyName}} utfall: Teckningsgrad {{rate}}',
            guarantorShare: ' där garanter stod för {{share}} av de tecknade aktierna',
            abbDirected:
                '{{companyName}} genomförde en {{issueType}} på teckningskurs {{price}} och inbringade {{amount}}',
            ipo: 'Utfallet i {{companyName}} IPO: Teckningsgrad {{rate}}',
            warrant: '{{companyName}} utfall i optionsinlösen för serie {{name}}: Teckningsgrad {{rate}}',
        },
        prospectus: {
            document: '{{companyName}} {{documentType}} finns nu tillgängligt',
            prospectus: 'prospekt',
            informationDocument: 'informationsdokument',
        },
        conversion: {
            toShares: '{{companyName}} cirka {{amount}} konverteras till aktier',
        },
    },
}

export const newsEventTypeSv = {
    cancellation: 'Avbruten',
    newCommitments: 'Nya åtaganden',
    guarantorCompensation: 'Garantiersättning',
    publication: 'Offentliggörande',
    prospectus: 'Prospekt',
    outcome: 'Utfall',
    terms: 'Villkor',
    conversion: 'Konvertering',
}
